module.exports = __webpack_public_path__ + "static/media/image-transfer.d2a185ee.svg";